import { render, staticRenderFns } from "./ClientePagador.vue?vue&type=template&id=6f69cb29&"
import script from "./ClientePagador.vue?vue&type=script&lang=js&"
export * from "./ClientePagador.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/custom/abbrasil/spa/dashboard/cadeia/apuracao/pendencias/ClientePagador.vue
// module id = 1218
// module chunks = 28